import { ArrayPriceType } from 'data/Price/types'

const fromArray = (raw: ArrayPriceType) => ({
  close: raw[4],
  high: raw[2],
  low: raw[3],
  open: raw[1],
  time: raw[0],
  volume: raw[5]
})

export default { fromArray }
